import axios from 'axios';
const formatSelect = document.getElementById('format');

if (formatSelect) {
    const id = document.getElementById('entity-id').value;
    const price = document.getElementById('unit-price');

    formatSelect.addEventListener('change', () => {
        const params = {
            action: 'units_by_volume',
            entity_id: id,
            volume: formatSelect.value,
        };
      
        axios.get('/wp-admin/admin-ajax.php', {
            params,
        }).then(({data}) => {
            if (data.data.length > 0) {
                price.innerText = data.data[0].price;
            }
        });
    });
}

const trackButtons = document.querySelectorAll("a[data-track]");
trackButtons.forEach(button => button.addEventListener("click", () => {
    const params = {
        action: 'track_button_press',
        entity_id: button.dataset.id,
        track: button.dataset.track,
    };
  
    axios.get('/wp-admin/admin-ajax.php', {
        params,
    });
}))

const numberBtn = document.querySelector(".show-number");

if (numberBtn && !/Android|iPhone/i.test(navigator.userAgent)) {
    numberBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const block = document.querySelector(".number-block");

        block.classList.remove("hidden");
    });
}

const numberBtn2 = document.querySelector(".show-number-2");

if (numberBtn2 && !/Android|iPhone/i.test(navigator.userAgent)) {
    numberBtn2.addEventListener("click", (e) => {
        e.preventDefault();
        const block = document.querySelector(".number-block-2");

        block.classList.remove("hidden");
    });
}


// WEBPACK FOOTER //
// ./scripts/entityPage.js